<template>
  <div
    style="
      width: 100%;
      display: flex;
      justify-content: flex-start;
      font-size: 7px;
      font-family: Arial, Helvetica, sans-serif;
    "
  >
    <div
      style="
        width: 22%;
        border-right: 1px dotted #000;
        margin-right: 10px;
        padding-right: 10px;
        text-align: right;
      "
    >
      <img :src="logoInBase64" alt="agency logo" height="35px" />
    </div>
    <!-- eslint-disable vue/no-v-html -->
    <div
      class="text-br-line"
      style="width: 63%; align-self: center; white-space: pre-line;"
      v-html="pdfFooterMessage"
    ></div>
  </div>
</template>

<script>
export default {
  props: ["logoInBase64", "pdfFooterMessage"],
};
</script>
